import React from 'react';
import { useTheme } from 'emotion-theming';

/**
 * Displays star svg
 *
 * Takes in variants "nofill", "full", and "half" based on how much you want to fill in a star
 *
 * @param {String} props.height :: height of the svg
 * @param {String} props.variant :: variant controls how much of the star is filled in
 * @param {String} props.width :: width of the svg
 */
export var Star = function Star(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'tertiaryLight' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '25px' : _ref$height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'nofill' : _ref$variant,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '25px' : _ref$width;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var fillHalf = false;
  var fillFull = false;
  var starColor = colors.gray[400];
  var fillColor = colors[color];

  switch (variant) {
    case 'half':
      fillHalf = true;
      break;

    case 'full':
      fillFull = true;
      break;

    default:
  }

  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 26",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: "0",
    y: "0",
    width: "13",
    height: "26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FINAL",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BDC_Profile-Page-1---Combined-Sections",
    transform: "translate(-473.000000, -415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-Card",
    transform: "translate(0.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stars-Copy",
    transform: "translate(386.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1/2-Star",
    transform: "translate(87.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stars",
    transform: "translate(1.000000, 1.000000)",
    fill: fillFull ? fillColor : starColor
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3797576,19.3350636 L4.71150144,22.9912025 C4.44175923,23.0198081 4.24356937,22.9786541 4.11693186,22.8677407 C3.99029435,22.7568273 3.9284353,22.5702216 3.93135471,22.3079237 L5.19140323,14.6460343 L0.384561786,9.75946768 C0.0646944923,9.38976424 -0.0556305772,9.03276209 0.0235865781,8.68846123 C0.102803733,8.34416036 0.354538802,8.14331952 0.778791784,8.08593869 L7.55514428,7.05902544 L10.6316288,0.557903 C10.8793192,0.184666522 11.1286955,-0.00130114455 11.3797576,0 C11.6308198,0.00147537099 11.8815046,0.190208145 12.131812,0.566198322 L15.204371,7.05902544 L22.3034246,8.18165536 C22.7587787,8.32656743 22.9908491,8.52762266 22.999636,8.78482103 C23.0084229,9.04201941 22.8581065,9.32549775 22.5486868,9.63525605 L17.568112,14.6460343 L18.7566203,21.8729142 C18.7812337,22.2955092 18.691601,22.5795611 18.4877222,22.7250698 C18.2838434,22.8705786 17.9754784,22.8705786 17.5626271,22.7250698 L11.3797576,19.3350636 Z",
    id: "Star"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Star-Filled"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), fillHalf && /*#__PURE__*/React.createElement("path", {
    d: "M12.4347323,20.4284697 L5.73426232,24.1022711 C5.463217,24.1310149 5.2640697,24.0896621 5.13682042,23.9782129 C5.00957113,23.8667637 4.94741325,23.6792565 4.95034677,23.4156915 L6.21648248,15.7167881 L1.38641957,10.8066149 C1.06500703,10.4351254 0.944100676,10.0763986 1.02370052,9.73043447 C1.10330037,9.38447031 1.35625155,9.18265922 1.78255406,9.1250012 L8.59164256,8.09312701 L11.6829893,1.56059818 C11.9318763,1.18555863 12.1824573,0.99869257 12.4347323,1 C12.6870073,1.0014825 12.9389031,1.19112702 13.1904198,1.56893358 L16.2778221,8.09312701 L23.4111706,9.22118026 C23.8687245,9.3667924 24.101916,9.5688189 24.1107454,9.82725978 C24.1195747,10.0857007 23.9685322,10.3705485 23.6576177,10.6818032 L18.6529821,15.7167881 L19.847232,22.9785804 C19.8719643,23.4032169 19.7818986,23.6886411 19.5770349,23.8348528 C19.3721711,23.9810645 19.0623164,23.9810645 18.6474708,23.8348528 L12.4347323,20.4284697 Z",
    id: "Star",
    fill: fillColor,
    mask: "url(#mask-2)"
  }))))))));
};